module.exports = __webpack_public_path__ + "img/emploi.29094dea.svg";